import React from 'react';

const CTA = ({ 
  title = "Let's Build Future Together.",
  buttonText = "Get Started Now",
  buttonLink = "contact.html",
  imageUrl = "assets/images/cta/cta-bg.png",
  imageAlt = ""
}) => {
  return (
    <section className="tj-cta-section">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="cta-area">
              <div className="cta-content">
                <h2 className="title title-anim">{title}</h2>
                <div className="cta-btn wow fadeInUp" data-wow-delay=".6s">
                  <a className="tj-primary-btn btn-dark" href={buttonLink}>
                    <span className="btn-text"><span>{buttonText}</span></span>
                    <span className="btn-icon"><i className="tji-arrow-right-long"></i></span>
                  </a>
                </div>
              </div>
              <div className="cta-img">
                <img src={imageUrl} alt={imageAlt} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;